// import React from 'react';
// import { Navigate } from 'react-router-dom';

// function ProtectedRoute({ children, requiredAuthentication, requiredPermissions = [] }) {
//   const isAuthenticated = false; // Replace with actual authentication logic
//   const userPermissions = []; // Replace with actual user permissions

//   if (requiredAuthentication && !isAuthenticated) {
//     return <Navigate to="/login" />;
//   }

//   if (requiredPermissions.length > 0) {
//     const hasPermission = requiredPermissions.every(permission =>
//       userPermissions.includes(permission)
//     );
//     if (!hasPermission) {
//       return <Navigate to="/unauthorized" />; // Define unauthorized route
//     }
//   }

//   return children;
// }

// export default ProtectedRoute;

import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuthenticationContext } from "../services/slices/AuthenticationSlicer";

const ProtectedRoute = ({ children, requiredPermissions = [] }) => {
  const location = useLocation();
  const { state: userState } = useAuthenticationContext();
  const { redirectPath, setRedirectPath } = useAuthenticationContext();
  const isAuthenticated = userState.userData !== null; 
  if (!isAuthenticated) {
    if(!window.location.pathname.includes('/login') && !window.location.pathname.includes('/personalDetails')){
      let pathName = window.location.pathname === '/questionnaire' ? '/confirm-request' : window.location.pathname
      // setRedirectPath(pathName);
      return <Navigate to={`/login?step='0'&callback=${pathName}`} replace state={{ from: location }} />;
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
    
  }
  return children;
};

export default ProtectedRoute;
